import type { JSX, ReactNode, Ref } from "react";
import { cn } from "@/lib/utils";

// Confirm/discard actions for the assistant panels. On phones it floats as a
// sticky bar (above the Feedback button) so Apply/Discard stay in reach while
// the provider scrolls through a long proposal; from `sm` up it is a plain
// right-aligned row. Two columns on phones; give a third, primary button
// `col-span-2 order-first sm:order-0` to put it full width on top.
// bottom-2, not more: on phones #app-content already reserves 72px of bottom
// padding for the Feedback button, and sticky offsets count from inside that
// padding, so a larger offset left the bar floating mid-screen over the diff.
export const AssistantActions = ({
  children,
  className,
  ref,
}: {
  children: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}): JSX.Element => (
  <div
    ref={ref}
    className={cn(
      "sticky bottom-2 z-10 mb-16 grid grid-cols-2 gap-2 rounded-xl border bg-background/95 p-2 shadow-lg backdrop-blur-sm",
      "[&>button]:h-11 [&>button]:w-full",
      "sm:static sm:mb-0 sm:flex sm:justify-end sm:border-0 sm:bg-transparent sm:p-0 sm:shadow-none sm:backdrop-blur-none",
      "sm:[&>button]:h-9 sm:[&>button]:w-auto",
      className,
    )}
  >
    {children}
  </div>
);
